export const B2B_PA17109_REALTOR_COMMISSION_KNOWLEDGE = 'b2b_pa17109_realtor_commission_knowledge';

export const EXPERIMENTS: string[] = [B2B_PA17109_REALTOR_COMMISSION_KNOWLEDGE];
